import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from './services/data';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs/operators';

/**
 * Unión de roles que pueden entrar al área /dashboard (alineado con menús en sidenav).
 * Incluye permisos granulares `access_*` que antes quedaban fuera y bloqueaban usuarios válidos.
 */
const DASHBOARD_ENTRY_ROLES = [
  'Admin',
  'Pastor',
  'Liderazgo',
  'Secretaría',
  'Tesorería',
  'Obrero',
  'access_finanzas',
  'access_membresia',
  'access_usuarios',
  'access_reports',
] as const;

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router, private dataService: DataService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.authService.user$.pipe(
      take(1),
      map(user => {
        if (!user) {
          return this.router.createUrlTree(['']);
        }

        const userRoles = this.dataService.getUserRoles();
        const tieneAcceso = userRoles.some((role: string) =>
          (DASHBOARD_ENTRY_ROLES as readonly string[]).includes(role)
        );

        if (tieneAcceso) {
          return true;
        }
        return this.router.createUrlTree(['']);
      })
    );
  }
}
